import storageClient from"./storageClient";export const storage={l:storageClient(),s:storageClient(true)};export default storage;